import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Select } from '@artosera/ui';
import { usePrevisionTresorerie, type Horizon, type Prevision } from '../../api/tresorerie.js';
import { useShellContext } from '../shell/context.js';
import { Field } from '../Field.js';
import { TresorerieCadre, Montant, DateJour, EtatRequete } from './commun.js';
import styles from './Tresorerie.module.css';

export function TableauPrevision({
  prevision,
  court = false,
}: {
  prevision: Prevision;
  court?: boolean;
}) {
  const { t } = useTranslation('regie');
  const label = (cle: string) => t(`tresorerie.${cle}`);
  return (
    <>
      <p>
        {label('soldeDepart')} <Montant cents={prevision.depart.soldeCentimes} /> ·{' '}
        <DateJour date={prevision.depart.le} />
      </p>
      <p>
        {label('seuil')} <Montant cents={prevision.seuilCentimes} />
      </p>
      {prevision.alertes.map((a) => (
        <p role="status" className={styles.alerte} key={a.le}>
          {label('sousSeuil')} <DateJour date={a.le} /> · <Montant cents={a.soldeCentimes} />
        </p>
      ))}
      {prevision.sourcesExclues.length > 0 && (
        <section>
          <h2>{label('sourcesExclues')}</h2>
          <ul>
            {prevision.sourcesExclues.map((s) => (
              <li key={s}>
                {label(`sources.${s}`)} — {label('sourceExclue')}
              </li>
            ))}
          </ul>
        </section>
      )}
      <div className={styles.tableau}>
        <table>
          <caption>{label('prevision')}</caption>
          <thead>
            <tr>
              {[
                'periode',
                'soldeDebut',
                'factures',
                'enRetard',
                'pipeline',
                'depenses',
                'charges',
                'reversements',
                'remboursements',
                'soldeFin',
              ].map((c) => (
                <th scope="col" key={c}>
                  {label(`sources.${c}`)}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {(court ? prevision.pas.slice(0, 3) : prevision.pas).map((p) => (
              <tr key={p.debut} className={p.sousSeuil ? styles.alerte : undefined}>
                <th scope="row">
                  <DateJour date={p.debut} /> — <DateJour date={p.fin} />
                </th>
                {[
                  p.soldeDebut,
                  p.encaissements.factures,
                  p.encaissements.enRetard,
                  p.encaissements.pipeline,
                  p.decaissements.depenses,
                  p.decaissements.charges,
                  p.decaissements.reversements,
                  p.decaissements.remboursements,
                  p.soldeFin,
                ].map((v, n) => (
                  <td key={n}>
                    <Montant cents={v} />
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}
function Contenu() {
  const { galerieSlug } = useShellContext();
  const { t } = useTranslation('regie');
  const [horizon, setHorizon] = useState<Horizon>('13s');
  const q = usePrevisionTresorerie(galerieSlug, horizon);
  return (
    <>
      <Field htmlFor="horizon" label={t('tresorerie.horizon')}>
        <Select
          id="horizon"
          value={horizon}
          onValueChange={(v) => setHorizon(v as Horizon)}
          options={(['13s', '6m', '12m'] as const).map((h) => ({
            value: h,
            label: t(`tresorerie.horizons.${h}`),
          }))}
        />
      </Field>
      <EtatRequete requete={q} />
      {q.data && <TableauPrevision prevision={q.data} />}
    </>
  );
}
export function PrevisionPage() {
  return (
    <TresorerieCadre titre="prevision">
      <Contenu />
    </TresorerieCadre>
  );
}
